import { useContext, useEffect, useRef, useState } from "react";
import { SuperviseesLeavePlanColumns } from "../data";
import { useManageTableWithSearchParams } from "../../../../helpers/useManageTable";
import CustomStyledTable from "../../../../components/table/CustomStyledTable";
import { useSearchParams } from "react-router-dom";
import TableFilter from "../../../../components/table/filter/TableFilter";
import useEditFormStore from "../../../../state-management/useEditFormStore";
import { EmployeeSupervisees } from "../../../../routes";
import { LeavePlanDto } from "../../../../models/leave-plan.dto";
import { useGetLeavePlan } from "../../../../services/leave-plan.service";
import LeavePlanDetailsModal from "../modals/LeavePlanDetailsModal";
import { superviseesLeavePlanColumns } from "../tanstack-columns";
import TanStackEmployeeTable from "../../../../components/table/TanStackEmployeeTable";
import { useTableConfiguration } from "../../../../helpers/useTableConfiguration";
import { TableId } from "../../../../models/table-configuration.dto";
import useUserStore from "../../../../state-management/useUserStore";

const SuperviseesLeavePlansView = () => {
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
	const [searchParams] = useSearchParams();
	const requestId = searchParams.get("id");
	const [openLeavePlanDetailsModal, setOpenLeavePlanDetailsModal] =
		useState(false);
	const supervisees = useContext(EmployeeSupervisees);
	const currentUser = useUserStore().currentUser.user;
	const { formDataValues, setFormData } = useEditFormStore();

	useEffect(() => {
		if (requestId) {
			setOpenLeavePlanDetailsModal(true);
		}
	}, [requestId]);

	const { tableAPIRef, tableData, isLoading, pageCount } =
		useManageTableWithSearchParams<LeavePlanDto>({
			fetchHook: useGetLeavePlan,
			options: { queryMode: "SUPERVISEES" },
		});

	return (
		<>
			<div className="flex justify-between mb-6">
				<TableFilter
					fields={[
						{
							title: "",
							fieldName: "",
							fieldType: "SORT",
							options: [
								{
									title: "Intended Start Date",
									fieldName: "intendedStartDate",
								},
								{
									title: "Intended End Date",
									fieldName: "intendedReturnDate",
								},
								{
									title: "Date Created",
									fieldName: "createdAt",
								},
								{
									title: "Date Modified",
									fieldName: "modifiedAt",
								},
							],
						},
						{
							title: "Supervisee",
							fieldName: "employeeId",
							fieldType: "SELECT_FIELD",
							options: supervisees || [],
							mapTexts: ["firstName", "lastName"],
						},
						{
							title: "Intended Start Date",
							fieldName: "intendedStartDate",
							fieldType: "DATE_RANGE",
						},
						{
							title: "Intended End Date",
							fieldName: "intendedReturnDate",
							fieldType: "DATE_RANGE",
						},
					]}
				/>
			</div>
			<TanStackEmployeeTable
				tableId={TableId.SUPERVISEES_LEAVE_PLANS}
				data={tableData}
				columns={superviseesLeavePlanColumns}
				loading={isLoading}
				onRowClick={(row, event) => {
					setFormData(row);
					setAnchorEl(event.currentTarget);
				}}
				onActionClick={(row, event) => {
					setFormData(row);
					setAnchorEl(event.currentTarget);
				}}
				initialColumnVisibility={{}}
				pageSize={10}
				pageCount={pageCount}
				apiRef={tableAPIRef}
			/>
			{/* <CustomStyledTable
				rows={tableData}
				columns={SuperviseesLeavePlanColumns}
				apiRef={tableAPIRef}
				loading={isLoading}
				pageCount={pageCount}
			/> */}
			{openLeavePlanDetailsModal && (
				<LeavePlanDetailsModal
					open={openLeavePlanDetailsModal}
					setOpen={setOpenLeavePlanDetailsModal}
				/>
			)}
		</>
	);
};

export default SuperviseesLeavePlansView;
